export const getElementHeight = (selecter:string) => {
    return document.querySelector<HTMLElement>(selecter)?.clientHeight ?? 0;
}